import { Address } from '@spartacus/core';
import {DeliveryMode} from '@spartacus/cart/base/root';

declare module '@spartacus/cart/base/root' {

  interface DeliveryMode {
    selected: boolean;
  }
}

declare module '@spartacus/core' {
  interface Address {
    nameSuffix: string;
  }
}

export class PlaceOrderForm {
  purchaseOrderNumber?: string;
  deliveryTicket?: string;
  selectedDeliveryModeCode: string;
  selectedDeliveryAddressId?: string;
  isDirectDelivery?: boolean;
  directDeliveryAddress: Address;
}

export interface PlaceOrderResponse {
  status: string;
  messages?: string[];
}

export interface CheckoutData {
  deliveryModes: DeliveryMode[];
  deliveryAddresses: Address[];
  directDeliveryAllowed: boolean;
}
